import {CarStatusPill} from "../Cars/CarStatusPill";
import {DocumentCheckIcon} from "@heroicons/react/24/outline";
import React from "react";
import {CarBuyStatusEnum} from "../../Enums/CarBuyStatusEnum";

export const PurchaseTypePill = React.memo(({car, className = "w-[100px]"}) => {
    return (
        <>
            {car.buy_status === CarBuyStatusEnum.confirmed && !car.is_sold &&
                <div className="flex items-center">
                    <CarStatusPill title={car.expected_in_stock_date ? 'ETA ' + car.expected_in_stock_date : 'Confirmed'} explanation="Carzelle has purchased the car so we can guarantee that it is available for your purchase" bgColor='bg-confirmed' className={`${className} text-xs`}/>
                </div>
            }

            {car.buy_status === CarBuyStatusEnum.inTransit && !car.is_sold &&
                <div className="flex items-center">
                    <CarStatusPill title={"In Transit " + car.expected_in_stock_date} explanation="The car is being transported to our stock" bgColor='bg-confirmed' className={`${className} text-xs`}/>
                </div>
            }

            {car.buy_status === CarBuyStatusEnum.fastDelivery && !car.is_sold &&
                <div className="flex items-center">
                    <CarStatusPill title="In Stock" Icon={car.documentsStockStatus === 'in_stock' ? DocumentCheckIcon : null} explanation={`Car is in stock <b>${car.stock_location ? "at " + car.stock_location : ''}</b> and is available for immediate delivery`} bgColor='bg-fast-delivery' foreColor="text-white" className={`${className} text-xs`}/>
                </div>
            }

            {car.buy_status === CarBuyStatusEnum.listing && !car.is_sold &&
                <div className="flex items-center">
                    <CarStatusPill title='Partner Listing' explanation="Reserve this car now, and we'll promptly confirm its availability with you." bgColor='bg-presales' foreColor="text-gray-700" className={`${className} text-xs`}/>
                </div>
            }
        </>
    )
});